import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

export const useTwoFactorStatus = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["two-factor-status", user?.id],
    queryFn: async () => {
      if (!user) return null;

      const { data, error } = await supabase
        .from("profiles")
        .select("two_factor_verified")
        .eq("id", user.id)
        .single();

      if (error) {
        console.error("Error fetching 2FA status:", error);
        return null;
      }

      return data;
    },
    enabled: !!user,
    staleTime: 1000 * 60, // 1 minute
  });
};
